import React from 'react';
import LandingPage from './features/landingPage/LandingPage';

function App() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default App;
